export function buildGradientBorderStyle(
    colors?: string[],
    borderWidth = 2,
    borderRadius = 10,
    direction = 'to right'
) {
    const fallbackColors = ['#FFFFFF']
    const appliedColors = colors?.length ? colors : fallbackColors

    const gradient =
        appliedColors.length === 2
            ? `linear-gradient(${direction}, ${appliedColors[0]}, ${appliedColors[1]})`
            : appliedColors.length >= 3
              ? `linear-gradient(${direction}, ${appliedColors[0]}, ${appliedColors[1]}, ${appliedColors[2]})`
              : appliedColors[0]

    return {
        position: 'relative' as const,
        padding: `${borderWidth}px`,
        borderRadius: `${borderRadius}px`,
        backgroundImage: gradient,
        boxSizing: 'border-box' as const,
    }
}
